var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#DBF7F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3225_1270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.063 27.7912C18.063 26.0225 18.063 24.2539 18.063 22.4868C18.063 21.3384 18.5798 20.8259 19.751 20.8212C22.9357 20.8071 26.013 20.2884 28.918 18.9354C30.6475 18.1117 32.2396 17.0316 33.639 15.7324C34.709 14.7559 35.2701 14.7512 36.3416 15.7465C40.0922 19.2322 44.6188 20.704 49.6765 20.815C49.9657 20.815 50.2581 20.8009 50.5442 20.8306C51.3344 20.9087 51.8718 21.4321 51.886 22.1977C51.965 26.7709 52.2148 31.3473 51.5699 35.9049C50.797 41.3624 48.7708 46.195 44.4939 49.9198C41.8371 52.2338 38.7551 53.7962 35.425 54.9196C35.1529 55.0217 34.8532 55.0267 34.5778 54.9336C29.547 53.2275 25.1721 50.612 22.1138 46.1669C19.9881 43.0795 18.9117 39.6156 18.3981 35.9564C18.0275 33.2511 17.9153 30.5173 18.063 27.7912ZM32.795 39.5828C33.2865 39.6328 33.6643 39.3734 34.0199 39.0422C36.4144 36.8142 38.8199 34.5956 41.2065 32.3597C41.717 31.8816 42.6289 31.4395 42.5973 30.8864C42.5657 30.3333 41.7059 29.8661 41.2713 29.313C40.8919 28.8286 40.6501 28.9036 40.2392 29.2974C37.9901 31.452 35.6952 33.5597 33.4556 35.7221C33.0004 36.1627 32.8139 36.0845 32.4488 35.6549C31.5843 34.6409 30.6471 33.6893 29.762 32.6863C29.4901 32.3738 29.3257 32.3488 29.0286 32.6441C28.586 33.0917 28.1106 33.5064 27.6061 33.8846C27.23 34.1612 27.3296 34.3424 27.5824 34.6127C28.9691 36.1095 30.3489 37.611 31.7218 39.1172C31.8489 39.2753 32.013 39.4003 32.2 39.4815C32.387 39.5626 32.5913 39.5974 32.795 39.5828Z",
    fill: "#0BC9BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3225_1270",
    x: 11,
    y: 12,
    width: 48,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0431373 0 0 0 0 0.788235 0 0 0 0 0.745098 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_1270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_1270",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.584410f7d5326a45515085096620887f.svg";
export { ForwardRef as ReactComponent };